import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination } from '@/types';
import { ReportsService } from '@/modules/reports/services';
import ReportsServiceGetters from './getters';
import ReportsServiceMutations from './mutations';
import ReportsServiceState from './state';

const reportsService = new ReportsService();

export default class ReportsServiceActions extends Actions<
  ReportsServiceState,
  ReportsServiceGetters,
  ReportsServiceMutations,
  ReportsServiceActions
> {
  async get_service_reports() {
    try {
      const filtersEmpty = Boolean(this.state.years.length && this.state.organizations.length);

      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const { is_download } = this.state;
      const payload = {
        filters: this.state.filters,
        filters_exist: filtersEmpty,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      if (!this.state.is_download) {
        this.mutations.TOGGLE_LOADING(true);
        this.mutations.TOGGLE_IS_DOWNLOAD_LOADING(false);
      } else {
        this.mutations.TOGGLE_IS_DOWNLOAD_LOADING(true);
      }

      const { data, meta } = await reportsService.get_service_reports(payload, is_download);

      if (!filtersEmpty) {
        this.mutations.SET_YEARS(data.filters.years);
        this.mutations.SET_ORGANIZATION(data.filters.organizations);
      }

      this.mutations.SET_SERVICES(data.items);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
      return true;
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      this.mutations.TOGGLE_LOADING(false);
      this.mutations.TOGGLE_IS_DOWNLOAD_LOADING(false);
    }
  }
}
